/* eslint-disable react-hooks/exhaustive-deps */
import { Alert } from '@material-ui/lab';
import axios from 'axios';
import queryString from 'query-string';
import { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import styled from 'styled-components';
import BookingAPI from '../api/booking.api';
import { bugsnagNotify } from '../bugsnag';
import Button from '../components/common/Button';
import Footer from '../components/Footer';
import HeaderOLD from '../components/OLD_Header';

const Style = styled.div`
    h1 {
        margin-bottom: 16px;
    }

    p {
        margin-bottom: 32px;
    }

    .cncl-button-container {
        display: flex;
        button:first-child {
            flex-basis: 50%;
            margin-right: 16px;
            background: transparent;
            border: 1px solid #ebebeb;
            color: #1c1c1c;
        }
        button:last-child {
            flex-basis: 50%;
        }

        @media screen and (min-width: 768px) {
            button:first-child {
                width: 128px;
                flex-basis: auto;
            }
            button:last-child {
                width: 128px;
                flex-basis: auto;
                flex-grow: 0;
            }
        }
    }

    .cncl-success-msg {
        font-weight: 500;
    }
`;

const api = new BookingAPI();

const CancelBooking: FunctionComponent<RouteComponentProps> = ({ history }) => {
    const params: any = queryString.parse(location.search);
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<string | null>(null);
    const [success, setSuccess] = useState<boolean | null>(null);
    const [isCancelAllowed, setIsCancelAllowed] = useState<boolean | null>(
        null,
    );
    const [isOnWaitingList, setIsOnWaitingList] = useState<boolean | null>(
        null,
    );

    const { t } = useTranslation();

    useEffect(() => {
        if (!params.guid) {
            return;
        }

        const ct = axios.CancelToken.source();

        api.isCancelAllowed(params.guid, ct)
            .then((res) => {
                setIsCancelAllowed(res.data.success);
                setIsOnWaitingList(res.data.isWaitingList);
                if (!res.data.success) {
                    setMessage(res.data.message);
                }
            })
            .catch((e) => {
                if (!axios.isCancel(e)) {
                    alert('Error fetching is cancel allowed.');
                }
            });
    }, []);

    return (
        <>
            <Style>
                <div style={{ padding: '16px' }} className="container">
                    <HeaderOLD inverted />
                </div>
                <div className="container">
                    <h1>
                        {!isOnWaitingList
                            ? t('pages.cancelBooking.cancelBooking')
                            : t('pages.cancelBooking.removeFromWaitingList')}
                    </h1>

                    {isCancelAllowed === null && <div>Loading...</div>}

                    {(!params.guid || isCancelAllowed === false) && (
                        <Alert severity="error">
                            {t('pages.cancelBooking.contactDirectly')}
                        </Alert>
                    )}

                    {success === null && params.guid && isCancelAllowed && (
                        <>
                            <p>
                                {!isOnWaitingList
                                    ? t('pages.cancelBooking.areYouSure')
                                    : t(
                                          'pages.cancelBooking.areYouSureWaitingList',
                                      )}
                            </p>
                            <div className="cncl-button-container">
                                <Button onClick={() => history.replace('/')}>
                                    {t('pages.cancelBooking.back')}
                                </Button>
                                <Button
                                    onClick={() => {
                                        setIsLoading(true);

                                        const cancelToken =
                                            axios.CancelToken.source();
                                        api.cancelBookingByGuid(
                                            params.guid,
                                            cancelToken,
                                        )
                                            .then((res) => {
                                                setSuccess(res.data.success);
                                                setMessage(res.data.message);
                                                setIsLoading(false);
                                            })
                                            .catch((e) => {
                                                if (!axios.isCancel(e)) {
                                                    bugsnagNotify(e);
                                                }
                                                setSuccess(false);
                                                setMessage(
                                                    'Error cancelling booking. Please contact the restaurant for cancellation.',
                                                );
                                                setIsLoading(false);
                                            });
                                    }}
                                    isLoading={isLoading}
                                >
                                    {t('pages.cancelBooking.confirm')}
                                </Button>
                            </div>
                        </>
                    )}

                    {message && <p className="cncl-success-msg">{message}</p>}
                </div>
            </Style>
            <Footer />
        </>
    );
};

export default CancelBooking;
